// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-wrapper, .checkbox-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
  gap: 7px;
}

.form-check-label {
  margin-left: 3px;
  font-size: 12px;
}

.radio-option {
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  padding: 2px 5px;
}

.form-check-input {
  cursor: pointer;
}

.form-check-input[type=radio] {
  border-radius: 50%;
  border-color: #d3d3d3;
}

.form-check-input[type=checkbox] {
  border-color: #d3d3d3;
}

.form-check-input[type=radio]:checked, .form-check-input[type=checkbox]:checked {
  background-color: #0A56AE;
  border-color: #0A56AE;
}

@media (min-width: 1920px) {
  .form-check-label {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/formelements/FormCheckElements.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;AACJ;;AAEA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,qBAAA;AACJ;;AAEA;EACI;IACI,eAAA;EACN;AACF","sourcesContent":[".radio-wrapper, .checkbox-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: start;\n    gap: 7px;\n}\n\n.form-check-label {\n    margin-left: 3px;\n    font-size: 12px;\n}\n\n.radio-option {\n    border: 1px solid #d3d3d3;\n    border-radius: 4px; \n    padding: 2px 5px;\n}\n\n.form-check-input {\n    cursor: pointer;\n}\n\n.form-check-input[type=radio] {\n    border-radius: 50%;\n    border-color: #d3d3d3;\n}\n\n.form-check-input[type=checkbox] {\n    border-color: #d3d3d3;\n}\n\n.form-check-input[type=radio]:checked, .form-check-input[type=checkbox]:checked {\n    background-color: #0A56AE;\n    border-color: #0A56AE;\n}\n\n@media (min-width: 1920px) {\n    .form-check-label {\n        font-size: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
